import React, { useState } from 'react'
const wordpress = true
const imagepath = wordpress ? '/wp-content/reactpress/apps/idesign/' : '/'
const techData = {
  'Web Development': [
    { name: 'HTML', image: 'https://img.icons8.com/color/48/html-5.png' },
    { name: 'CSS', image: 'https://img.icons8.com/color/48/css3.png' },
    {
      name: 'JavaScript',
      image: 'https://img.icons8.com/color/48/javascript.png',
    },
    {
      name: 'React',
      image: 'https://img.icons8.com/color/48/react-native.png',
    },
    {
      name: 'Angular',
      image: 'https://img.icons8.com/color/48/angularjs.png',
    },
  ],
  'Mobile Development': [
    { name: 'Flutter', image: 'https://img.icons8.com/color/48/flutter.png' },
    {
      name: 'React Native',
      image: 'https://img.icons8.com/color/48/react-native.png',
    },
    { name: 'Swift', image: 'https://img.icons8.com/color/48/swift.png' },
    { name: 'Kotlin', image: 'https://img.icons8.com/color/48/kotlin.png' },
    {
      name: 'Objective-C',
      image: `${imagepath}assets/images/technology/objc.png`,
    },
    {
      name: 'Cordova',
      image: `${imagepath}assets/images/technology/cordova.svg`,
    },
  ],
  'Backend Development': [
    {
      name: 'Java',
      image: 'https://img.icons8.com/color/48/java-coffee-cup-logo.png',
    },
    {
      name: 'Spring Boot',
      image: 'https://img.icons8.com/color/48/spring-logo.png',
    },
    {
      name: 'Hibernate',
      image: `${imagepath}assets/images/technology/hibernate.svg`,
    },
    { name: 'Node.js', image: 'https://img.icons8.com/color/48/nodejs.png' },
  ],
  Database: [
    {
      name: 'MySQL',
      image: 'https://img.icons8.com/fluency/48/mysql-logo.png',
    },
    {
      name: 'Amazon RDS',
      image: `${imagepath}assets/images/technology/aws-rds.svg`,
    },
    {
      name: 'PostgreSQL',
      image: 'https://img.icons8.com/color/48/postgreesql.png',
    },
    {
      name: 'DynamoDB',
      image: `${imagepath}assets/images/technology/dynamo.svg`,
    },
    { name: 'MongoDB', image: 'https://img.icons8.com/color/48/mongodb.png' },
    {
      name: 'Firebase',
      image: 'https://img.icons8.com/color/48/firebase.png',
    },
    // {
    //   name: 'Sybase',
    //   image:
    //     `${imagepath}assets/images/technology/sybase.png`,
    // },
  ],
  DevOps: [
    {
      name: 'AWS',
      image: 'https://img.icons8.com/color/48/amazon-web-services.png',
    },
    { name: 'GCP', image: 'https://img.icons8.com/color/48/google-cloud.png' },
    {
      name: 'Azure',
      image: `${imagepath}assets/images/technology/azure.svg`,
    },
    { name: 'Docker', image: 'https://img.icons8.com/color/48/docker.png' },
    {
      name: 'Kubernetes',
      image: 'https://img.icons8.com/color/48/kubernetes.png',
    },
    { name: 'Jenkins', image: 'https://img.icons8.com/color/48/jenkins.png' },
  ],
}

export default function TechDesign() {
  const categories = Object.keys(techData)
  const [selectedCategory, setSelectedCategory] = useState(categories[0])

  return (
    <div className='container mt-4'>
      <div className='row border' style={{ height: '500px' }}>
        {/* Left: Category Menu */}
        <div className='col-12 col-md-4  border-end p-3 techbackground'>
          {/* <h5 className='mb-3'>Select Category</h5> */}
          <div className='d-md-block d-flex flex-row flex-md-column overflow-auto gap-2'>
            {categories.map((category) => (
              <div
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`p-2 mb-2 rounded cursor-pointer ${
                  selectedCategory === category ? 'bg-primary text-white' : ' '
                }`}
                style={{ cursor: 'pointer' }}
              >
                {category}
              </div>
            ))}
          </div>
        </div>

        {/* Right: Technology List */}
        <div className='col-12 col-md-8 p-4 tech'>
          <h4 className='mb-4'>{selectedCategory}</h4>
          <div className='row row-cols-2 row-cols-sm-3 row-cols-md-3 g-3'>
            {techData[selectedCategory].map((tech, idx) => (
              <div key={idx} className='col'>
                <div className='card h-100 text-center shadow-sm'>
                  <div className='card-body'>
                    <img
                      src={tech.image}
                      alt={tech.name}
                      className='d-block mx-auto mb-2'
                      style={{ width: '60px', height: '60px' }}
                    />
                    <h6 className='card-title'>{tech.name}</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
